import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { forgotPasswordApiCall } from "../../utils/Apicalls";
import Header from "../../components/common/header/Header";
import Footer from "../../components/common/footer/Footer";
import SpinnerShow from "../../components/Spinner";
import "./forgot-password.css";

function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const validateForm = () => {
    if (!email.trim()) {
      setError("Please enter your email");
      return false;
    }
    
    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError("Please enter a valid email address");
      return false;
    }
    
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    setLoading(true);
    setError("");
    
    try {
      const result = await forgotPasswordApiCall({
        email: email
      });
      
      setLoading(false);
      
      if (result?.status) {
        setSuccess(true);
      } else {
        setError(result?.message || "Failed to process your request. Please try again.");
      }
    } catch (err) {
      setLoading(false);
      setError("An error occurred. Please try again later.");
      console.error("Forgot password error:", err);
    }
  };

  const handleLoginClick = () => {
    navigate("/login");
  };

  const handleSignupClick = () => {
    navigate("/signup");
  };

  const handleBackToLogin = () => {
    navigate("/login");
  };

  return (
    <>
      <Header />
      <div className="forgot-password-container">
        <div className="forgot-password-card">
          {loading && (
            <div className="spinner-container">
              <SpinnerShow />
            </div>
          )}
          
          {!loading && !success && (
            <>
              <h1 className="forgot-password-title">Forgot Password</h1>
              
              <p className="forgot-password-description">
                Enter your email address and we'll send you a link to reset your password.
              </p>
              
              {error && (
                <div className="forgot-password-error">
                  <Alert severity="error">{error}</Alert>
                </div>
              )}
              
              <form className="forgot-password-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="email">Email <span className="required">*</span></label>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    required
                  />
                </div>
                
                <button type="submit" className="send-reset-link-btn">
                  Send Reset Link
                </button>
              </form>
              
              <div className="forgot-password-options">
                <div className="remember-password">
                  <span>Remember your password?</span>
                  <button className="login-link" onClick={handleLoginClick}>
                    Log in
                  </button>
                </div>
                
                <div className="no-account">
                  <span>Don't have an account?</span>
                  <button className="signup-link" onClick={handleSignupClick}>
                    Sign up
                  </button>
                </div>
                
                <button className="back-to-login-link" onClick={handleBackToLogin}>
                  <ArrowBack className="back-icon" /> Back to login
                </button>
              </div>
            </>
          )}
          
          {!loading && success && (
            <div className="success-container">
              <h2>Password Reset Email Sent</h2>
              <p>
                We've sent a password reset link to your email address. 
                Please check your inbox and follow the instructions to reset your password.
              </p>
              <button className="back-to-login-btn" onClick={handleLoginClick}>
                Back to Login
              </button>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ForgotPasswordPage;




